<template>
    <div class="home">
        <div class="header">
          <device-list @success="getList" @onLoading="onLoading"></device-list>
          <el-input size="mini" v-model="listQuery.jqbh" placeholder="请输入税控盘编号" style="width:13%;margin:0px 10px 0 10px"></el-input>
          <el-input size="mini" v-model="listQuery.tax_no" placeholder="请输入纳税人识别号" style="width:13%;margin:0px 10px 0 10px"></el-input>
          <el-button size="mini" type="primary" plain @click="getList(this.listQuery.name)">查询</el-button>
        </div>
        <div>
        <el-table :data="tableData" stripe style="width: 100%" border size="mini" v-loading="loading">
            <el-table-column align="center" type="index" label="序号" width="50" />
            <el-table-column align="center" prop="name" label="纳税人名称" min-width="180" />
            <el-table-column align="center" prop="tax_no" label="纳税人识别号" min-width="180" />
            <!-- <el-table-column align="center" prop="mac" label="税控盘编号" /> -->
            <!-- <el-table-column align="center" prop="name" label="盘组设备名称" /> -->
            <!-- <el-table-column align="center" prop="mac" label="Mac地址" /> -->
            <el-table-column align="center" prop="type" label="纳税人性质" min-width="180"/>
            <!-- <el-table-column align="center" prop="mac" label="是否有签章" /> -->
            <!-- <el-table-column align="center" prop="mac" label="是否有证书" /> -->
            <el-table-column align="center" label="操作" width="80">
                <template v-slot="scope">
                <el-button type="text" size="small" @click="del(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        </div>
    </div>
</template>

<script>
import { zyTaxDiscList , zyTaxDiscDel  } from "@/api/ea";
import deviceList from './components/deviceList.vue'
export default {
  components: { deviceList }, 
    data(){
        return{
            tableData:[],
            loading:false,
            listQuery:{
                name:'',
                jqbh:'',
                tax_no:''
            }
        }
    },
    methods:{
        getList(e){
            this.listQuery.name = e
            console.log(this.listQuery.name);
            console.log(this.listQuery.jqbh);
            zyTaxDiscList(this.listQuery).then(res=>{
                if(res.data.msg == "success"){
                    this.loading = false
                    this.tableData = res.data.data.list
                }  
            })
        },
        del(id){   
            zyTaxDiscDel({id:id}).then(res=>{
                if(res.data.msg == "success"){
                    this.$qzfMessage("删除成功")
                    this.getList(this.listQuery.name)
                } 
            })
        },
        onLoading(loading){
            this.loading = loading
        }
    }
}
</script>

<style lang="scss" scoped>

</style>